/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungVerlaufListResponseDto } from '../../models/lexplus-anforderung-verlauf-list-response-dto';
import { LexplusVerlaufFilterEnum } from '../../models/lexplus-verlauf-filter-enum';

export interface ArchivierteAnforderungControllerGetArchivierteAnforderungVerlaufV1$Params {
  anforderungsversionID: number;
  filter?: LexplusVerlaufFilterEnum;
  page?: number;
  limit?: number;
}

export function archivierteAnforderungControllerGetArchivierteAnforderungVerlaufV1(http: HttpClient, rootUrl: string, params: ArchivierteAnforderungControllerGetArchivierteAnforderungVerlaufV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungVerlaufListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, archivierteAnforderungControllerGetArchivierteAnforderungVerlaufV1.PATH, 'get');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.query('filter', params.filter, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungVerlaufListResponseDto>;
    })
  );
}

archivierteAnforderungControllerGetArchivierteAnforderungVerlaufV1.PATH = '/v1/compliance/archiv/{anforderungsversionID}/verlauf';
